import { render, staticRenderFns } from "./simulacao-seguro-vida.html?vue&type=template&id=f53b2964&scoped=true&"
import script from "./simulacao-seguro-vida.js?vue&type=script&lang=js&"
export * from "./simulacao-seguro-vida.js?vue&type=script&lang=js&"
import style0 from "./simulacao-seguro-vida.scss?vue&type=style&index=0&id=f53b2964&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53b2964",
  null
  
)

export default component.exports